import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../components/Utils/CallApi";
import { setPageLoadingTrue, setPageLoadingFalse } from "./appSlice";
import { setError } from "./appSlice";

export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const response = await get("template/category/list", "", {});
      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }
      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const saveCategory = createAsyncThunk(
  "categories/saveCategory",
  async (category, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const response = await post("template/category/save", category, {});
      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }
      if (response.data) {
        dispatch(addCategory(response.data));
      }
      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async (category, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const response = await post("template/category/save", category, {});
      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }
      dispatch(editCategory(response.data));
      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const addCategory = (category) => ({
  type: "categories/addCategory",
  payload: category,
});

export const editCategory = (updatedCategory) => ({
  type: "categories/editCategory",
  payload: updatedCategory,
});

const categorySlice = createSlice({
  name: "categories",
  initialState: {
    categories: null,
    loading: false,
    error: null,
  },
  reducers: {
    addCategory: (state, action) => {
      if (action.payload) {
        state.categories.push(action.payload);
      }
    },
    editCategory: (state, action) => {
      const index = state.categories.findIndex(
        (category) => category.id === action.payload.id
      );
      if (index !== -1) {
        state.categories[index] = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default categorySlice.reducer;
